import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from "axios";

import CustomDropDown from './../Common/customDropDown';
import CustomUniversityDropDown from './CustomUniversityDropdown';
import Loader from '../Common/loader';
import { FOLDERPATH, FOLDERPATHROUTER } from '../../Constants/config';
import { getMasterUniversityEducation } from '../../Actions/DigiLockerActions';
import { useDispatch } from 'react-redux';

function DigiSelect(props) {

  //Handling TP Dropdown
  const tpDropdown = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    //[name]: null,
  });


  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    console.log(formData);
  }

  const { type, options, attachOther, verificationType, name, id, placeholder, fieldId, isRequired, errId, caseCheckId, returnType, value, hiddenValue, selectedLabel, checkDetailsIndex, fieldName, isDisabled, digilockerEnabled, onClear } = props;


  ///////////////////////////////////////////////////////////

  const [selectedOptionId, setSelectedOptionId] = useState();
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [showFilterDivUniv, setShowFilterDivUniv] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [runRequest, setRunRequest] = useState(false);
  const [autoSuggestOptionData, setAutoSuggestOption] = useState([]);
  const [autoSuggestUniversity, setAutoSuggestUniversity] = useState([])
  const inputText = useRef();
  const [keywordType, setKeywordType] = useState()
  const [filterOptions, setFilterOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false);

  // const dispatch = useDispatch();
  const dispatch = useDispatch();


  useEffect(() => {
    if(options.length > 0){
      setFilterOptions(options)
    }
  },[options])
  
  const inputTypeHandler = (e) => {
    setKeyword(e.target.value);
    setSelectedOptionId(null);
    setRunRequest(true);
    
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const inputTypeHandlerUniv = (e) => {
    setKeyword(e.target.value);
    if(e.target.value.length === 0 && onClear){
        onClear()
    }
    setSelectedOptionId(null);
    setRunRequest(true);
    setKeywordType('university')
    
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [currentSelectedVal, setCurrentSelectedVal] = useState(null);

  const handleThirdPartyFloatingLabel = (e) => {
    //console.log('test'+currentSelectedVal);
    let parent = e.target.parentElement;
   // alert(keyword);
    while (!parent.classList.contains('floating-label'))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains('focused')) {
      if (currentSelectedVal !== null || value || keyword !== '') {
        return false;
      } else {
        parent.children[1].classList.remove('focused');
        setCurrentSelectedVal(null);
      }
    } else {
      parent.children[1].classList.add('focused');
    }
  }

  useEffect(() => {

    let apiData;

    const fetchCompany = async (value) => {


      const requestData = {
        term: value,
        verification_type: verificationType,
      };

      const requestDigiData = {
        term: keyword,
        // verification_type: verificationType,
        "token": "4v9cDKekg3SHT92jxebcNgZY8L0/T12L/7vA20XN3I8=:QzQgR5WNdvwLEIfCJIthVg==",
      };
      // const headers = {
      //   "Content-Type": "application/json",
      //   Authorization: storedToken,
      // };

      const headers = {
        "Content-Type": "application/json",
        "Username": "ibridge",
        "Password": "ibridge@2020",
      };

      //   axios.defaults.baseURL = API_URL;
      apiData = await axios.post(
        "/GenericApi/getMasterUniversity",
        // "/GenericApi/getVerificationData",
        requestDigiData,
        {
          headers,
        }
      );

      let optionsFormat = [];
      if (apiData.data.length === 0 && attachOther) {

        optionsFormat.push({ value: "other", name: "other" });

      } else {
        optionsFormat = [...apiData.data];
      }
      setAutoSuggestOption(optionsFormat);
      setShowFilterDiv(true);
    };

    if (typeof keyword == "string" && keyword.length === 0) {
      console.log("string is empty");
      setShowFilterDiv(false);
      setAutoSuggestOption([]);
      //return false;
    } else {

      //  let storedToken = userData.token;
      if (selectedOptionId === null) {
        if(keywordType == 'university'){
          if(keyword.length > 2)
          fetchUniversity(keyword);
          // fetchCompany(keyword);
        }else{
          fetchCompany(keyword);
        }
      } else {
        setShowFilterDiv(false);
      }
    }

  }, [runRequest, keyword]);

  const fetchUniversity = (val) => {
    if(val.trim() != ''){
      // setIsLoading(true);
      let payload = {search: keyword}
      dispatch(getMasterUniversityEducation(payload, setUniversityRes))
  
    }else{
      setFilterOptions(options);
      setShowFilterDivUniv(false);
      setAutoSuggestUniversity([]);
    }

  }

  const setUniversityRes = (apiData) => {
    // let apiData;
    let optionsFormat = [];
    if (apiData?.length === 0 && attachOther) {
        
                Object.entries(apiData).forEach((element, index) => {
                  // const [key, value] = element;
                  optionsFormat.push({
                    label:element[1].org_name,
                    value:element[1]
                  });
                });
                optionsFormat.push({ label: "other", value: "other" });
        
    } else {
                Object.entries(apiData).forEach((element, index) => {
                  // const [key, value] = element;
                  optionsFormat.push({
                    label:element[1].org_name,
                    value:element[1]
                  });
                });
                // optionsFormat = [...apiData.data];
    }
              // setAutoSuggestOption(optionsFormat);
              // setShowFilterDiv(true);
          

      let data = optionsFormat;
      // let data = JSON.parse(localStorage.getItem('master_ts_university'))
      // let res = data?.filter((obj) => {
      //   return(
      //     obj.label.toLowerCase().includes(val.toLowerCase())
      //     )
      //   })
      // optionsFormat.push({ value: "Other", label: "Other" });

        setFilterOptions(optionsFormat);
        setAutoSuggestUniversity(optionsFormat);
        setShowFilterDivUniv(true);
        // setIsLoading(false);
  }

  const fetchUniversity1 = async(val) => {
    if(val.trim() != ''){
      // setIsLoading(true);
      getMasterUniversityEducation('', setUniversityRes)

      let apiData;
      // const fetchUniversity = async (value) => { 
        let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

              const requestDigiData = {
                search: keyword,
                "token": userLocalData.id,
              }
              const headers = {
                "Content-Type": "application/json",
                "Username": "ibridge",
                "Password": "ibridge@2020",
              };
        
              //   axios.defaults.baseURL = API_URL;
    //  const { data : result } = await axios.post(FOLDERPATH + "/GenericApi/login", requestData, {

              // apiData = await axios.post( 
              //   "/GenericApi/getMasterUniversity",
              //   // "/GenericApi/getVerificationData",
              //   requestDigiData,
              //   {
              //     headers,
              //   }
              // );
              apiData = await axios.post(
                "/GenericApi/getMasterUniversity",
                requestDigiData,
                {
                  headers: headers,
                }
              );
        
              let optionsFormat = [];
              if (apiData?.data?.data?.length === 0 && attachOther) {
        
                Object.entries(apiData?.data?.data).forEach((element, index) => {
                  // const [key, value] = element;
                  optionsFormat.push({
                    label:element[1].org_name,
                    value:element[1]
                  });
                });
                optionsFormat.push({ label: "other", value: "other" });
        
              } else {
                Object.entries(apiData?.data?.data).forEach((element, index) => {
                  // const [key, value] = element;
                  optionsFormat.push({
                    label:element[1].org_name,
                    value:element[1]
                  });
                });
                // optionsFormat = [...apiData.data];
              }
              // setAutoSuggestOption(optionsFormat);
              // setShowFilterDiv(true);
          

      let data = optionsFormat;
      // let data = JSON.parse(localStorage.getItem('master_ts_university'))
      // let res = data?.filter((obj) => {
      //   return(
      //     obj.label.toLowerCase().includes(val.toLowerCase())
      //     )
      //   })
      // optionsFormat.push({ value: "Other", label: "Other" });

        setFilterOptions(optionsFormat);
        setAutoSuggestUniversity(optionsFormat);
        setShowFilterDivUniv(true);
        // setIsLoading(false);
      }else{
        setFilterOptions(options);
        setShowFilterDivUniv(false);
        setAutoSuggestUniversity([]);
      }
  }

  const [reactSelect, setReactSelect] = useState();
  console.log(reactSelect);

  useEffect(() => {

    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }
    if(returnType === "docType"){
      // value = selectedOption;
      // const univObj = selectedOption.value;
    setReactSelect({ value: value?.value, label: value?.label });

    }else{

      setReactSelect({ value: value, label: stateValue });
    }
    // setFormData(() => ({
    //   [name + "_value"]: hiddenValue,
    // }));


  }, []);

  useEffect(() => {
    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }

    // setReactSelect({ value: value, label: stateValue });
    if(returnType === "docType"){
      // value = selectedOption;
      // const univObj = selectedOption.value;
    setReactSelect({ value: value?.value, label: value?.label });

    }else{

      setReactSelect({ value: value, label: stateValue });
    }
  },[value, options])




  useEffect(() => {

    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }

   // setReactSelect({ value: value, label: stateValue });
    setFormData(() => ({
      [name + "_value"]: hiddenValue,
    }));


  }, [hiddenValue]);

  const handleChangeUnivAuto = () => {
    const otherOption = {
      "value": "Other",
      "name": "Other"
    }

    setCurrentSelectedVal(otherOption.value);
    setReactSelect(otherOption);
    setFormData((prevState) => ({
      [name + "_value"]: otherOption.value,
    }));
    props.selectOption([{ "name": name, "value": otherOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName }]);
    setShowFilterDiv(false);
    setShowFilterDivUniv(false);
    if (type === 3) {

      inputText.current.value = otherOption.name;

    }
  }

  const handleChange = (selectedOption) => {
    // alert(JSON.stringify(selectedOption));
    //Need to call this for Other digilocker disabled flow
    const otherOption = {
      "value": "Other",
      "name": "Other"
  }
    console.log('this is handleChange....', selectedOption)
    setCurrentSelectedVal(selectedOption.value);

    setReactSelect(selectedOption);

    let value = selectedOption.value;
    if (returnType === 'name') {
      value = selectedOption.name;
    }
    if(returnType === 'univName' || "docType"){
      value = selectedOption;
      // const univObj = selectedOption.value;
    }

    // var value_element = document.getElementById(name+"_value");
    // value_element.value = selectedOption.value;
    setFormData((prevState) => ({
      [name + "_value"]: selectedOption.value,
    }));

    // alert(JSON.stringify(value))

    props.selectOption([{ "name": name, "value": value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName }]);
    setShowFilterDiv(false);
    setShowFilterDivUniv(false);
    //setKeyword(selectedOption.name);

    if (type === 3) {

      inputText.current.value = selectedOption.name;

    }

    //if this is an auto suggeest and other is selected then do something

    if (type === 3 && selectedOption.value === 'other') {

     // alert("other selected");

    }

    //if this is an auto suggeest and other is selected then do something

  };


  let classNameD=props.pageName;
  let finalClassName="";
  if(classNameD=="Professional License"){
    finalClassName="col-sm-11 col-md-12 col-xl-11";
  }else if(classNameD=="add_que"){
    finalClassName="col-sm-12 col-md-12 col-xl-12";
  }else if (fieldName=="university_board"){
    finalClassName="col-sm-12 col-md-12 col-lg-4";
  }
  // else if (placeholder=="College / Institute / School"){
  //   finalClassName="col-sm-12 col-md-12 col-lg-7";
  // }

  
  else{
    finalClassName="col-sm-4 col-md-12 col-xl-4";
  }

  useEffect(() => {
    if(digilockerEnabled && returnType === 'univName' && currentSelectedVal === null) {
      handleChangeUnivAuto();
    }  
  },[digilockerEnabled, returnType])

  const disableKeyHandler = (e) => {
    // Disable the "Enter" key
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent the default action (e.g., submitting a form)
      console.log("Enter key is disabled!");
    }
  };

  useEffect(() => {
    if(value){
      inputText.current.value = value;
    }else if(value == ''){
      inputText.current.value = '';
    }
  }, [value,name])

  return (
    <>

      {(() => {
        if (
          type &&
          type === 1
        ) {
          return (
            <>
            {/* {isLoading && <Loader />} */}
              <div className={finalClassName}>
                <div className="form-group">
                  <div className="floating-label tp-dropdown" ref={tpDropdown}>
                    <Select
                      value={reactSelect}
                      onChange={handleChange}
                      name={name}
                      id={name}
                      options={options}
                      isSearchable={type === 2 ? true : false}
                      placeholder=""
                      onFocus={handleThirdPartyFloatingLabel}
                      onBlur={handleThirdPartyFloatingLabel}
                      isDisabled={isDisabled}
                    // isSearchable={false}
                    />

                    <label htmlFor={id} className={(value) && 'focused'}>{placeholder} {isRequired == 1 && <sup className="text-danger">*</sup>}</label>

                   
                  </div>
                  <p className="err text-danger" id={errId}></p>
                  <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />

                </div>
              </div>
            </>
          );
        } else if (
          type &&
          type === 3
        ) {
          return (
            <>
              <div className={finalClassName}>
            
                <div className="form-group">
                  <div className="floating-label">
                    {/* <label>Course Name</label> */}
                    <input
                      type="text"
                      className="form-control"
                      name={name}
                      id={id}
                      ref={inputText}
                      // onChange={inputTypeHandler}
                      onChange={inputTypeHandlerUniv}
                      onKeyDown={disableKeyHandler}
                      autoComplete="off"
                      defaultValue={value == '' ? null : value}
                      disabled={isDisabled}
                    />
                 
                    <label htmlFor={props.id ? props.id : ''} className={(formData[name + "_value"] || keyword) && 'focused'}>{placeholder}{isRequired && <sup className="text-danger">*</sup>}</label>
                  </div>
                  {showFilterDivUniv && (
                    <CustomUniversityDropDown
                      optionData={autoSuggestUniversity}  
                      selectOption={handleChange}
                      classes="suggestion-list has-scroll"
                    />
                  )}
                  {showFilterDiv && (
                    <CustomDropDown
                      optionData={autoSuggestOptionData}  
                      selectOption={handleChange}
                      classes="suggestion-list has-scroll"
                    />
                  )}

                  <p className="err text-danger" id={errId}></p>

                  <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />
                </div>
              </div>
            </>
          );
        }
      })()}

    </>
  );
}

export default DigiSelect;
